import FallbackImage from '../../../assets/images/Course1.jpg';

// Course photos are managed from the admin panel. The API returns a ready-made
// `imageUrl`; the local image is only shown when a course has no photo (or the
// photo fails to load).
export function getCourseImageSrc(course, apiImageUrl) {
  if (course?.imageUrl && course?.image) return course.imageUrl;
  if (course?.image) return `${apiImageUrl}cources/${encodeURIComponent(course.image)}`;
  return FallbackImage;
}

export { FallbackImage };
